import React from 'react';
import classNames from 'classnames';
import Card, { CardProps } from '@material-ui/core/Card';
import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props extends CardProps {}

function WidgetConfigCard(props: Props) {
  const classes = useStyles();
  const { className, ...restOfProps } = props;

  return <Card className={classNames(classes.root, className)} {...restOfProps} />;
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginRight: theme.spacing(3),
  },
}));

export default WidgetConfigCard;
